// export const ADD_USER = "ADD_USER";
export const CHECK_SUPER_USER_SUCCESS = "CHECK_SUPER_USER_SUCCESS";
export const CHECK_SUPER_USER_FAIL = "CHECK_SUPER_USER_FAIL";
export const SET_USER_TYPE = "SET_USER_TYPE";
export const FETCH_ACCESS_TOKEN = "FETCH_ACCESS_TOKEN";
// Bulk Disable user
export const CHECK_DISABLE_USER_SUCCESS = "CHECK_DISABLE_USER_SUCCESS";
export const CHECK_DISABLE_USER_FAIL = "CHECK_DISABLE_USER_FAIL";
// export const UPDATE_SUPER_USER = "UPDATE_SUPER_USER";
// export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_USER_SESSION = "SET_USER_SESSION";
export const FETCH_USER_START = "FETCH_USER_START";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";
export const SET_USER_EMPLOYEEID = "SET_USER_EMPLOYEEID";

// export const SEARCH_USERS = "SEARCH_USERS";
export const SEARCH_USERS_SUCCESS = "SEARCH_USERS_SUCCESS";
export const SEARCH_USERS_FAILED = "SEARCH_USERS_FAILED";
export const START_SEARCH = "START_SEARCH";
export const RESET_SEARCH_RESULT = "RESET_SEARCH_RESULT";
export const SET_SEARCH_CRITERIA = "SET_SEARCH_CRITERIA";
export const RESET_MEMRESPONSE = "RESET_MEMRESPONSE";
export const SET_ID_TYPE = "SET_ID_TYPE";
export const SET_IMPACTED_MEMBER = "SET_IMPACTED_MEMBER";
export const RESET_SEARCH_INDICATORS = "RESET_SEARCH_INDICATORS";

// Generic persisted search (keeps last search request per search type across tab switches)
export const SET_PERSISTED_SEARCH_REQUEST = "SET_PERSISTED_SEARCH_REQUEST";
export const CLEAR_PERSISTED_SEARCH_REQUEST = "CLEAR_PERSISTED_SEARCH_REQUEST";
export const CLEAR_ALL_PERSISTED_SEARCH_REQUESTS = "CLEAR_ALL_PERSISTED_SEARCH_REQUESTS";
// export const SET_SEARCH_RESULTS = "SET_SEARCH_CRITERIA";
export const SET_ERROR = "SET_ERROR";
export const SEARCH_PAGE_MESSAGE = "SEARCH_PAGE_MESSAGE";
export const SEARCH_ACTIVITY_LOG = "SEARCH_ACTIVITY_LOG";
export const IS_ACTIVITY_SEARCHED = "IS_ACTIVITY_SEARCHED"; 
export const SELECT_EVENT_ACTIVITY_LOG = "SELECT_EVENT_ACTIVITY_LOG";
export const ACTIVITY_LOG_STATUS = "ACTIVITY_LOG_STATUS";
export const ACTIVITY_LOG_USERID = "ACTIVITY_LOG_USERID";
export const SEARCH_ACTIVITY_FAILURE = "SEARCH_ACTIVITY_FAILURE";
export const ACTIVITY_LOG_PAGE_NUMBER = "ACTIVITY_LOG_PAGE_NUMBER";
export const ACTIVITY_LOG_SEARCH_STATE = "ACTIVITY_LOG_SEARCH_STATE"; 
export const ACTIVITY_LOG_NUMBER_OF_PAGES = "ACTIVITY_LOG_NUMBER_OF_PAGES";
export const ACTIVITY_LOG_BTN_ARR = "ACTIVITY_LOG_BTN_ARR";
export const ACTIVITY_LOG_BTN_ARR_INDEX = "ACTIVITY_LOG_BTN_ARR_INDEX";
export const SEARCH_ACTIVITY_NOT_FOUND = "SEARCH_ACTIVITY_NOT_FOUND";
export const ACTIVITY_LOG_SPINNER = "ACTIVITY_LOG_SPINNER";
export const AGENT_ID_DISABLED = "AGENT_ID_DISABLED";
export const CHECK_AGENT_ACCESS_SUCCESS = "CHECK_AGENT_ACCESS_SUCCESS";
export const CHECK_AGENT_ACCESS_FAIL = "CHECK_AGENT_ACCESS_FAIL";

//member
export const SELECT_MEMBER = "SELECT_MEMBER";
export const FETCH_MEMBER_DATA_SUCCESS = "FETCH_MEMBER_DATA_SUCCESS";
export const FETCH_MEMBER_DATA_FAILURE = "FETCH_MEMBER_DATA_FAILURE";
export const RESET_MEMBER_ERROR = "RESET_MEMBER_ERROR";
export const REBUILD_CACHE_START = "REBUILD_CACHE_START";
export const REBUILD_CACHE_SUCCESS = "REBUILD_CACHE_SUCCESS";
export const REBUILD_CACHE_FAILURE = "REBUILD_CACHE_FAILURE";
export const ADD_MEMBER_ELIGIBILITY = "ADD_MEMBER_ELIGIBILITY";
export const PERSONAL_INFO_SUCCESS = "PERSONAL_INFO_SUCCESS";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_FAILURE = "DELETE_ACCOUNT_FAILURE";
export const UPDATE_CACHE_SUCCESS = "UPDATE_CACHE_SUCCESS";
export const UPDATE_CACHE_FAILURE = "UPDATE_CACHE_FAILURE";
export const UPDATE_HSID_INFO_SUCCESS = "UPDATE_HSID_INFO_SUCCESS";
export const UPDATE_HSID_INFO_FAILURE = "UPDATE_HSID_INFO_FAILURE";
export const DELETE_ELIGIBILITY_START = "DELETE_ELIGIBILITY_START";
export const DELETE_ELIGIBILITY_SUCCESS = "DELETE_ELIGIBILITY_SUCCESS";
export const DELETE_ELIGIBILITY_FAILURE = "DELETE_ELIGIBILITY_FAILURE";
export const SET_DEL_ELIG_MESSAGE = "SET_DEL_ELIG_MESSAGE";
export const FETCH_PORTAL_CONFIG = "FETCH_PORTAL_CONFIG";
export const MERGE_PORTALS_LIST_ADMIN = "MERGE_PORTALS_LIST_ADMIN";
export const FETCH_PORTAL_CONFIG_SUCCESS = "FETCH_PORTAL_CONFIG_SUCCESS";
export const FETCH_PORTAL_CONFIG_FAILURE = "FETCH_PORTAL_CONFIG_FAILURE";
export const DELETE_SECONDARY_EMAIL_SUCCESS = "DELETE_SECONDARY_EMAIL_SUCCESS";
export const DELETE_SECONDARY_EMAIL_FAILURE = "DELETE_SECONDARY_EMAIL_FAILURE";
export const GET_REASON_FAILURE = "GET_REASON_FAILURE";
export const FETCH_IMPACTED_MEMBER_DATA_SUCCESS = "FETCH_IMPACTED_MEMBER_DATA_SUCCESS";
export const SET_ACCOUNT_SECURITY_TOGGLE = "SET_ACCOUNT_SECURITY_TOGGLE";
export const SET_INCIDENT_MEMBERS_LIST = "SET_INCIDENT_MEMBERS_LIST"; 
export const RESET_INCIDENT_MEMBERS_LIST = "RESET_INCIDENT_MEMBERS_LIST"; 
export const SET_DISABLED_MEMBER_STATUS = "SET_DISABLED_MEMBER_STATUS";
export const ERASE_ACCOUNT_SECURITY_REDUCERS = "ERASE_ACCOUNT_SECURITY_REDUCERS";
export const CLEAR_ENABLE_DISABLE_MSG = "CLEAR_ENABLE_DISABLE_MSG";

//Reference Data
export const FETCH_STATES_START = "FETCH_STATES_START";
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAILURE = "FETCH_STATES_FAILURE";

//Passkey
export const FETCH_PASSKEY_LIST_SUCCESS = "FETCH_PASSKEY_LIST_SUCCESS";
export const FETCH_PASSKEY_LIST_FAILURE = "FETCH_PASSKEY_LIST_FAILURE";
export const PASSKEY_TOGGLE_SUCCESS = "PASSKEY_TOGGLE_SUCCESS";
export const PASSKEY_TOGGLE_FAILURE = "PASSKEY_TOGGLE_FAILURE";
export const PASSKEY_DELETE_SUCCESS = "PASSKEY_DELETE_SUCCESS";
export const PASSKEY_DELETE_FAILURE = "PASSKEY_DELETE_FAILURE";
export const PASSKEY_LOADING = "PASSKEY_LOADING";


//Add Eligibility
export const FETCH_ELIG_PORTALS_START = "FETCH_ELIG_PORTALS_START";
export const FETCH_ELIG_PORTALS_SUCCESS = "FETCH_ELIG_PORTALS_SUCCESS";
export const FETCH_ELIG_PORTALS_FAILURE = "FETCH_ELIG_PORTALS_FAILURE";
export const FETCH_ELIG_PORTAL_INFO_START = "FETCH_ELIG_PORTAL_INFO_START";
export const FETCH_ELIG_PORTAL_INFO_SUCCESS = "FETCH_ELIG_PORTAL_INFO_SUCCESS";
export const FETCH_ELIG_PORTAL_INFO_FAILURE = "FETCH_ELIG_PORTAL_INFO_FAILURE";
export const FETCH_ELIG_PORTAL_INFO_TOGGLE = "FETCH_ELIG_PORTAL_INFO_TOGGLE"
export const SET_ADD_ELIGIBILITY_PORTAL = "SET_ADD_ELIGIBILITY_PORTAL";
export const ADD_ELIGIBILITY_START = "ADD_ELIGIBILITY_START";
export const ADD_ELIGIBILITY_SUCCESS = "ADD_ELIGIBILITY_SUCCESS";
export const ADD_ELIGIBILITY_FAILURE = "ADD_ELIGIBILITY_FAILURE";
export const FETCH_ELIG_FARO_ID_START = "FETCH_ELIG_FARO_ID_START";
export const FETCH_ELIG_FARO_ID_SUCCESS = "FETCH_ELIG_FARO_ID_SUCCESS";
export const FETCH_ELIG_FARO_ID_FAILURE = "FETCH_ELIG_FARO_ID_FAILURE";
export const FETCH_ELIG_GROUP_ID_START = "FETCH_ELIG_GROUP_ID_START";
export const FETCH_ELIG_GROUP_ID_SUCCESS = "FETCH_ELIG_GROUP_ID_SUCCESS";
export const FETCH_ELIG_GROUP_ID_FAILURE = "FETCH_ELIG_GROUP_ID_FAILURE";
export const SET_ELIG_DISPLAY_MESSAGE = "SET_ELIG_DISPLAY_MESSAGE";
export const ADD_ELIGIBILITY_MODAL_TOGGLE = "ADD_ELIGIBILITY_MODAL_TOGGLE";
export const MERGE_PORTALS_INFO = "MERGE_PORTALS_INFO";
export const MERGE_PORTALS_LIST = "MERGE_PORTALS_LIST";
export const FETCH_DISABLED_PORTAL_SUCCESS = "FETCH_DISABLED_PORTAL_SUCCESS";
export const FETCH_DISABLED_PORTAL_FAILURE = "FETCH_DISABLED_PORTAL_FAILURE";

//Modify Eligibility
export const SET_MODIFY_ELIGIBILITY_PORTAL = "SET_MODIFY_ELIGIBILITY_PORTAL";
export const SET_MODIFY_ELIGIBILITY_SELECTED_PORTAL = "SET_MODIFY_ELIGIBILITY_SELECTED_PORTAL";
export const MODIFY_PORTAL_ELIGIBILITY_START = "MODIFY_PORTAL_ELIGIBILITY_START";
export const MODIFY_PORTAL_ELIGIBILITY_SUCCESS = "MODIFY_PORTAL_ELIGIBILITY_SUCCESS";
export const MODIFY_PORTAL_ELIGIBILITY_FAILURE = "MODIFY_PORTAL_ELIGIBILITY_FAILURE";
export const MODIFY_PORTAL_ELIGIBILITY_MESSAGE = "MODIFY_PORTAL_ELIGIBILITY_MESSAGE";
export const MODIFY_ELIGIBILITY_MODAL_TOGGLE = "MODIFY_ELIGIBILITY_MODAL_TOGGLE";
export const SET_MEMBER_ELIG_MESSAGE = "SET_MEMBER_ELIG_MESSAGE";

//Add Account
export const FETCH_ACCOUNT_PORTALS_START = "FETCH_ACCOUNT_PORTALS_START";
export const FETCH_ACCOUNT_PORTALS_SUCCESS = "FETCH_ACCOUNT_PORTALS_SUCCESS";
export const FETCH_ACCOUNT_PORTALS_FAILURE = "FETCH_ACCOUNT_PORTALS_FAILURE";
export const FETCH_ACCOUNT_PORTAL_INFO_START = "FETCH_ACCOUNT_PORTAL_INFO_START";
export const FETCH_ACCOUNT_PORTAL_INFO_SUCCESS = "FETCH_ACCOUNT_PORTAL_INFO_SUCCESS";
export const FETCH_ACCOUNT_PORTAL_INFO_FAILURE = "FETCH_ACCOUNT_PORTAL_INFO_FAILURE";
export const FETCH_ACCOUNT_FARO_ID_START = "FETCH_FARO_ID_START";
export const FETCH_ACCOUNT_FARO_ID_SUCCESS = "FETCH_FARO_ID_SUCCESS";
export const FETCH_ACCOUNT_FARO_ID_FAILURE = "FETCH_FARO_ID_FAILURE";
export const FETCH_ACCOUNT_GROUP_ID_START = "FETCH_GROUP_ID_START";
export const FETCH_ACCOUNT_GROUP_ID_SUCCESS = "FETCH_GROUP_ID_SUCCESS";
export const FETCH_ACCOUNT_GROUP_ID_FAILURE = "FETCH_GROUP_ID_FAILURE";
export const ADD_ACCOUNT_START = "ADD_ACCOUNT_START";
export const ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS";
export const ADD_ACCOUNT_FAILURE = "ADD_ACCOUNT_FAILURE";
export const SET_DISPLAY_MESSAGE = "SET_DISPLAY_MESSAGE";
export const SET_SUPER_USER_DISPLAY_MESSAGE = "SET_SUPER_USER_DISPLAY_MESSAGE";
export const SET_ADD_ACCOUNT_PORTAL = "SET_ADD_ACCOUNT_PORTAL";

//Member Account
export const MODIFY_ACCOUNT_START = "MODIFY_ACCOUNT_START";
export const MODIFY_ACCOUNT_SUCCESS = "MODIFY_ACCOUNT_SUCCESS";
export const MODIFY_ACCOUNT_FAILURE = "MODIFY_ACCOUNT_FAILURE";
export const SET_PERSINFO_DISPLAY_MESSAGE = "SET_PERSINFO_DISPLAY_MESSAGE";
export const SET_MEMPOPUP_DISPLAY_MESSAGE = "SET_MEMPOPUP_DISPLAY_MESSAGE";
export const FETCH_MEMBER_ACCOUNT_PORTALS_START = "FETCH_MEMBER_ACCOUNT_PORTALS_START";
export const FETCH_MEMBER_ACCOUNT_PORTALS_SUCCESS = "FETCH_MEMBER_ACCOUNT_PORTALS_SUCCESS";
export const FETCH_MEMBER_ACCOUNT_PORTALS_FAILURE = "FETCH_MEMBER_ACCOUNT_PORTALS_FAILURE";
export const FETCH_LANGUAGE_INFO_SUCCESS = "FETCH_LANGUAGE_INFO_SUCCESS";
export const FETCH_LANGUAGE_INFO_FAILURE = "FETCH_LANGUAGE_INFO_FAILURE";
export const RESET_PERSONAL_INFO = "RESET_PERSONAL_INFO";
export const NAV_TO_PORTALPAGE = "NAV_TO_PORTALPAGE";

//Account Status
export const UNLOCK_USER_START = "UNLOCK_USER_START";
export const UNLOCK_USER_SUCCESS = "UNLOCK_USER_SUCCESS";
export const UNLOCK_USER_FAILURE = "UNLOCK_USER_FAILURE";
export const UNLOCK_RBA_START = "UNLOCK_RBA_START";
export const UNLOCK_RBA_SUCCESS = "UNLOCK_RBA_SUCCESS";
export const UNLOCK_RBA_FAILURE = "UNLOCK_RBA_FAILURE";
export const ENABLE_DISABLE_ACCOUNT_START = "ENABLE_DISABLE_ACCOUNT_START";
export const ENABLE_DISABLE_ACCOUNT_SUCCESS = "ENABLE_DISABLE_ACCOUNT_SUCCESS";
export const ENABLE_DISABLE_ACCOUNT_FAILURE = "ENABLE_DISABLE_ACCOUNT_FAILURE";
export const ENABLE_DISABLE_FAILURE = "ENABLE_DISABLE_FAILURE";

// Service Now Incidents
export const CREATE_SERVICE_NOW_START = "CREATE_SERVICE_NOW_START";
export const CREATE_SERVICE_NOW_SUCCESS = "CREATE_SERVICE_NOW_SUCCESS";
export const CREATE_SERVICE_NOW_FAILURE = "CREATE_SERVICE_NOW_FAILURE";
export const RESET_INCIDENT_DETAILS = "RESET_INCIDENT_DETAILS";
export const INCIDENT_FORM_TYPE = "INCIDENT_FORM_TYPE";
export const SHOW_INCIDENT_LOADER = "SHOW_INCIDENT_LOADER";

// Reset ACcount
export const RESET_ACCOUNT_START = "RESET_ACCOUNT_START";
export const RESET_PWD_SUCCESS = "RESET_PWD_SUCCESS";
export const RESET_PWD_FAILURE = "RESET_PWD_FAILURE";
export const RESET_SQ_SUCCESS = "RESET_SQ_SUCCESS";
export const RESET_SQ_FAILURE = "RESET_SQ_FAILURE";
export const VERIFY_EMAILPHONE_SUCCESS = "VERIFY_EMAILPHONE_SUCCESS";
export const VERIFY_EMAILPHONE_FAILURE = "VERIFY_EMAILPHONE_FAILURE";
export const UPDATE_USERNAME_SUCCESS = "UPDATE_USERNAME_SUCCESS";
export const UPDATE_USERNAME_FAILURE = "UPDATE_USERNAME_FAILURE";
export const SMS_OTP_TOKEN_START = "SMS_OTP_TOKEN_START";
export const SMS_OTP_TOKEN_STOP = "SMS_OTP_TOKEN_STOP";
export const SMS_OTP_TOKEN_SUCCESS = "SMS_OTP_TOKEN_SUCCESS";
export const SMS_OTP_TOKEN_FAILURE = "SMS_OTP_TOKEN_FAILURE";
export const VERIFY_OTP_TOKEN_SUCCESS = "VERIFY_OTP_TOKEN_SUCCESS";
export const VERIFY_OTP_TOKEN_FAILURE = "VERIFY_OTP_TOKEN_FAILURE";
export const INITIATE_ATTEST_SUCCESS = "INITIATE_ATTEST_SUCCESS";
export const INITIATE_ATTEST_FAILURE = "INITIATE_ATTEST_FAILURE";
export const VERIFY_OTP_TOKEN_LOCKED = "VERIFY_OTP_TOKEN_LOCKED";
export const SET_OTP_DISPLAY_MESSAGE = "SET_OTP_DISPLAY_MESSAGE";
export const DELETEPHONE_SUCCESS = "DELETEPHONE_SUCCESS";
export const DELETEPHONE_FAILURE = "DELETEPHONE_FAILURE";
export const OTP_GENERATED_FLAG = "OTP_GENERATED_FLAG";

export const SMS_OTP_TOKEN_START_IC = "SMS_OTP_TOKEN_START_IC";
export const SMS_OTP_TOKEN_SUCCESS_IC = "SMS_OTP_TOKEN_SUCCESS_IC";
export const SMS_OTP_TOKEN_FAILURE_IC = "SMS_OTP_TOKEN_FAILURE_IC";
export const OTP_GENERATED_FLAG_IC = "OTP_GENERATED_FLAG_IC";
export const OTP_GENERATED_MESSAGE_RESET_IC = "OTP_GENERATED_MESSAGE_RESET_IC";
export const TEMP_GENERATE_OTP_MESSAGE_RESET_IC = "TEMP_GENERATE_OTP_MESSAGE_RESET_IC";
export const VERIFY_OTP_TOKEN_SUCCESS_IC = "VERIFY_OTP_TOKEN_SUCCESS_IC";
export const VERIFY_OTP_TOKEN_FAILURE_IC = "VERIFY_OTP_TOKEN_FAILURE_IC";
export const VERIFY_OTP_TOKEN_LOCKED_IC = "VERIFY_OTP_TOKEN_LOCKED_IC";
export const SMS_OTP_TOKEN_LOADER_IC = "SMS_OTP_TOKEN_LOADER_IC";
export const DBIC_POLLING_SUCCESS_IC = "DBIC_POLLING_SUCCESS_IC";
export const DBIC_POLLING_FAILURE_IC = "DBIC_POLLING_FAILURE_IC";
export const SEND_DBIC_LINK_SUCCESS_IC = "SEND_DBIC_LINK_SUCCESS_IC";
export const SEND_DBIC_LINK_FAILURE_IC = "SEND_DBIC_LINK_FAILURE_IC";
export const RESEND_DBIC_LINK_SUCCESS_IC = "RESEND_DBIC_LINK_SUCCESS_IC";
export const RESEND_DBIC_LINK_FAILURE_IC = "RESEND_DBIC_LINK_FAILURE_IC";
export const RESET_RESEND_DBIC_LINK_MESSAGE_IC = "RESET_RESEND_DBIC_LINK_MESSAGE_IC";
export const RESET_SEND_DBIC_LINK_MESSAGE_IC = "RESET_SEND_DBIC_LINK_MESSAGE_IC";
export const RESET_EXPIRED_LINK_MESSAGE_IC = "RESET_EXPIRED_LINK_MESSAGE_IC";
export const GET_DBIC_PDB_SUCCESS_IC = "GET_DBIC_PDB_SUCCESS_IC";
export const GET_DBIC_PDB_FAILURE_IC = "GET_DBIC_PDB_FAILURE_IC";
export const GET_IDVERSE_RESULTS_SUCCESS_IC = "GET_IDVERSE_RESULTS_SUCCESS_IC";
export const GET_IDVERSE_RESULTS_FAILURE_IC = "GET_IDVERSE_RESULTS_FAILURE_IC";
export const START_POLLING_IC = "START_POLLING_IC";
export const RESET_DBIC_STATUS_IC = "RESET_DBIC_STATUS_IC";
export const INITIATE_ATTEST_SUCCESS_IC = "INITIATE_ATTEST_SUCCESS_IC";
export const INITIATE_ATTEST_FAILURE_IC = "INITIATE_ATTEST_FAILURE_IC";


// Bulk Disable Accounts
export const BULK_USER_ACTIVITY_START = "BULK_USER_ACTIVITY_START";
export const BULK_USER_ACTIVITY_STOP = "BULK_USER_ACTIVITY_STOP";
export const BULK_DISABLE_SUCCESS = "BULK_DISABLE_SUCCESS";
export const BULK_DISABLE_FAILURE = "BULK_DISABLE_FAILURE";
export const BULK_LOCKING_SUCCESS = "BULK_LOCKING_SUCCESS";
export const BULK_LOCKING_FAILURE = "BULK_LOCKING_FAILURE";
export const BULK_LDAP_UNLOCK_SUCCESS = "BULK_LDAP_UNLOCK_SUCCESS";
export const BULK_LDAP_UNLOCK_FAILURE = "BULK_LDAP_UNLOCK_FAILURE";
export const BULK_DELETE_SUCCESS = "BULK_DELETE_SUCCESS";
export const BULK_DELETE_FAILURE = "BULK_DELETE_FAILURE";
export const BULK_EIMP_SYNC_SUCCESS = "BULK_EIMP_SYNC_SUCCESS";
export const BULK_EIMP_SYNC_FAILURE = "BULK_EIMP_SYNC_FAILURE";
export const SET_BULKDISABLE_RESP_EMPTY = "SET_BULKDISABLE_RESP_EMPTY";
export const SET_BULKDISABLE_RSN = "SET_BULKDISABLE_RSN";
export const SET_FEATURE_RSN = "SET_FEATURE_RSN";

//Reporting
export const IS_REPORT_SEARCHED = "IS_REPORT_SEARCHED";
export const REPORT_LOAD_SPINNER = "REPORT_LOAD_SPINNER";
export const SEARCH_REPORTS = "SEARCH_REPORTS";
export const RESET_SEARCH_REPORTS = "RESET_SEARCH_REPORTS";
export const REPORT_SEARCH_STATE = "REPORT_SEARCH_STATE";
export const SEARCH_REPORT_FAILURE = "SEARCH_REPORT_FAILURE";
export const SEARCH_REPORT_NOT_FOUND = "SEARCH_REPORT_NOT_FOUND";


//Timer
export const START_TIMER = "START_TIMER";
export const RESET_TIMER = "RESET_TIMER";
export const CLOSE_TIMER = "CLOSE_TIMER";
export const CLOSE_POPUP = "CLOSE_POPUP";
export const DECREMENT_TIMER = "DECREMENT_TIMER";